// extracted by mini-css-extract-plugin
module.exports = {"dialogContainer":"LoginBox_dialogContainer__3_qps","container":"LoginBox_container__3WiqP","loginBox":"LoginBox_loginBox__3lltp"};